<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Квартиры
      <span v-if="total">({{ total }})</span>
      <router-link class="btn btn-primary" :to="{ name: 'apartment-add' }">+ Добавить квартиру</router-link><br/><br/>
      <router-link class="btn btn-primary" :to="{ name: 'apartment-bulk-add' }">+ Массово добавить квартиры</router-link>
    </h2>

    <resource-list
      url="/apartments"
      current-sort="number"
      init-sort-type="asc"
      resource-name="apartments"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'apartments',
  components: { resourceList },
  data () {
    return {
      total: null,
      fields: [
        { name: 'full_name', label: 'Полный адрес', sort: false },
        { name: 'number', label: '№ квартиры', sort: true },
        { name: 'client__balance', label: 'Баланс', money: true, sort: false }
      ],
      filters: {
        block: this.$route.params.block_id
      },
      actionRoutes: [
        { name: 'apartment-details', idName: 'apartment_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    updateTotal (val) {
      this.total = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// Apartments.vue?78198b5a